import React from 'react';
import { Box } from '@mui/material';
import { TipTapEditor } from '../../../TipTap';
import { styled } from '@mui/material/styles';

const EditorWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  '& .tiptap-editor-container': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  '& .tiptap-editor-container:focus-within': {
    borderColor: theme.palette.text.secondary,
  },
  '& .tiptap-editor-content': {
    padding: '0 !important',
    minHeight: 'auto !important',
  },
  '& .ProseMirror': {
    fontSize: '12px',
    padding: '8px 10px',
    outline: 'none',
    border: 'none',
    '& p': { margin: 0 },
  },
}));

export default function TextPreview({ field, onUpdate, palette, theme, availablePlaceholders }) {
  const isMultiline = field.multiline || false;
  const isNumber = field.type === 'number';

  return (
    <EditorWrapper>
      <TipTapEditor
        value={field.placeholder || ''}
        onChange={(val) => onUpdate({ placeholder: val })}
        showToolbar={false}
        stripHtml={true}
        availablePlaceholders={availablePlaceholders}
        placeholder={isNumber ? 'Enter a number...' : (isMultiline ? 'Enter your answer...' : 'Type your answer...')}
        minHeight={isMultiline ? '80px' : 'auto'}
      />
    </EditorWrapper>
  );
}
